import Cookies from 'js-cookie'

export const tourConfigs = {
  disableInteraction: true,
  steps: [
    {
      title: 'Bem-vindo à Segfy!',
      intro:
        'Vamos te mostrar os primeiros passos para começar a usar nossa plataforma. Em poucos cliques, você saberá onde configurar suas seguradoras, fazer cotações, acessar seu painel e muito mais. Preparado? Então vamos lá!',
      position: 'center'
    },
    {
      title: 'Configuração da Conta',
      element: '#submenu-corretoras',
      intro:
        'Aqui você encontra as configurações da sua corretora! Pode atualizar seus dados públicos e até personalizar sua logo, que será exibida em seus orçamentos enviados aos clientes.',
      position: 'right'
    },
    {
      title: 'Logins das Seguradoras',
      element: '#submenu-logins-seguradoras',
      intro:
        'Antes de começar, é essencial configurar os logins das seguradoras. Sem isso, você não conseguirá cotar! Vamos lá?',
      position: 'right'
    },
    {
      title: 'Tela de Cotação (Auto)',
      element: '#submenu-auto',
      intro:
        'Aqui você inicia suas cotações de seguro Auto! Mas não para por aí – temos muitos outros ramos disponíveis nos menus abaixo!',
      position: 'right'
    },
    {
      title: 'Painel de Cotações',
      element: '#submenu-painel',
      intro:
        'Quer revisar suas cotações anteriores? Tudo fica salvo neste painel para facilitar o seu dia a dia!',
      position: 'right'
    },
    {
      title: 'Arquivos de Pós-Venda',
      element: '#menu-propostas-e-apólices',
      intro:
        'Após fechar um negócio, os arquivos de apólices e documentos de pós-venda ficarão todos aqui. Buscamos diversos arquivos automaticamente e os demais você pode importar através desse menu.',
      position: 'right'
    },
    {
      title: 'Gerenciamento de contas',
      element: '#menu-item-gerenciar-conta',
      intro:
        'Neste menu você pode acompanhar seu histórico de pagamento, mudar informações de cobrança e gerenciar seus dados financeiros com a Segfy.',
      position: 'left'
    },
    {
      title: 'Chat de Suporte',
      intro:
        'Se tiver qualquer dúvida, é só chamar nosso time no chat aqui no cantinho da tela. Nosso horário de atendimento é de segunda a sexta, das 9h30 às 19h.',
      element: '#cp-popover-btn',
      position: 'right'
    }
  ],
  showProgress: false,
  showBullets: true,
  showStepNumbers: true,
  exitOnOverlayClick: true,
  exitOnEsc: true,
  nextLabel: 'Próximo',
  prevLabel: 'Anterior',
  doneLabel: 'Concluir',
  onExit: () => {
    Cookies.set('tour_completed', 'true', {
      expires: 2,
      domain: process.env.VUE_APP_COOKIE_DOMAIN || undefined
    })
  },
  onBeforeChange: (targetElement) => {
    if (targetElement.id === 'submenu-corretoras') {
      document.querySelector('#menu-configurações').click()
    }

    if (targetElement.id === 'submenu-auto') {
      document.querySelector('#menu-hfy').click()
    }

    if (targetElement.id === 'menu-propostas-e-apólices') {
      document.querySelector('#menu-user-options__BV_button_').click()
    }
  },
  onComplete: () => {
    document.querySelector('#menu-hfy').click()
  }
}
